import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@patternfly/react-core';
import { useEffect, useRef, useState } from 'react';
import { useMount } from 'react-use';
import { User } from '../../api/security/User';
import { TAppNotification } from '../../api/types/AppNotification';

type Props = {
	onClick: () => void;
};

export default function Notifications(props: Props) {
	const [notifications, setNotifications] = useState<TAppNotification[]>([]);
	const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
	const [animate, setAnimate] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const unreadCountRef = useRef(unreadNotificationCount);
	unreadCountRef.current = unreadNotificationCount;

	useMount(() => {
		if (firstLoad) {
			getAllNotifications();
		}
	});

	useEffect(() => {
		const intervalId = setInterval(() => {
			getAllNotifications();
		}, 60 * 1000); // 60 seconds

		return () => clearInterval(intervalId);
	}, []);

	const getAllNotifications = () => {
		User.GetNotifications()
			.then((notifications) => {
				setNotifications(notifications);
				setFirstLoad(false);
			})
			.catch((error) => {
				console.error(error);
			});
	};

	useEffect(() => {
		if (notifications.length > 0) {
			const unreadCount = notifications.filter((n) => !n.read).length;
			setUnreadNotificationCount(unreadCount);

			if (unreadCountRef.current !== unreadCount) {
				setAnimate(true);
				setTimeout(() => {
					setAnimate(false);
				}, 2000);
			}
		}
	}, [notifications]);

	return (
		<Icon
			onClick={() => props.onClick()}
			style={{
				width: '1.5rem',
				height: '1.5rem',
				color: '#8A8D90',
				cursor: 'pointer',
			}}
			alt={'notification'}
			isInline
		>
			<FontAwesomeIcon icon={faBell} />
			{unreadNotificationCount > 0 && (
				<span className={`zi-notification-count ${animate ? 'bounce-animation' : ''}`}>
					{unreadNotificationCount}
				</span>
			)}
		</Icon>
	);
}
